import { render, staticRenderFns } from "./AppFooterPlanes.vue?vue&type=template&id=54cfbeba&scoped=true"
import script from "./AppFooterPlanes.vue?vue&type=script&lang=js"
export * from "./AppFooterPlanes.vue?vue&type=script&lang=js"
import style0 from "./AppFooterPlanes.vue?vue&type=style&index=0&id=54cfbeba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cfbeba",
  null
  
)

export default component.exports